import { getEnv } from "@/env";
import { useEffect } from "react";

export const useBranchIORender = () => {
  const NEXT_PUBLIC_MOBILE_BANNER_KEY = "NEXT_PUBLIC_MOBILE_BANNER_KEY";
  const bannerKey = getEnv(NEXT_PUBLIC_MOBILE_BANNER_KEY);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (!window.analytics || typeof window.analytics.page !== "function") {
      return;
    }

    window.analytics.page();

    if (!window.location.pathname.includes("/webview")) {
      /* eslint-disable */
      (function (
        b: any,
        r: any,
        a: any,
        n: any,
        c: any,
        h: any,
        _: any,
        s: any,
        d: any,
        k: any,
      ) {
        if (!b[n] || !b[n]._q) {
          for (; s < _.length; ) c(h, _[s++]);
          d = r.createElement(a);
          d.async = true;
          d.src = "https://cdn.branch.io/branch-latest.min.js";
          k = r.getElementsByTagName(a)[0];
          k.parentNode?.insertBefore(d, k);
          b[n] = h;
        }
      })(
        window,
        document,
        "script",
        "branch",
        function (b: any, r: any) {
          (b as any)[r] = function () {
            (b as any)._q.push([r, arguments]);
          };
        },
        { _q: [], _v: 1 },
        "addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(
          " ",
        ),
        0,
        null,
        null,
      );

      (window as any).branch.init(bannerKey);
      /* eslint-enable */
    }

    // Add finished div for Cypress
    const finishedDiv = document.createElement("div");
    finishedDiv.className = "initial-client-render-finished d-none";
    document.body.appendChild(finishedDiv);
  }, [bannerKey]);
};
